/**
 * Legal Disclaimers Section - Sections 9-12: Disclaimers, Liability, Indemnification, Termination
 */

import React from 'react';

export const LegalDisclaimersSection: React.FC = () => (
  <>
    <section>
      <h2 className="text-xl font-semibold mb-3">9. Disclaimers</h2>
      <div className="space-y-2 text-gray-600">
        <p>
          The Service is provided on an &ldquo;as is&rdquo; and &ldquo;as available&rdquo; basis. We make no 
          warranties about the accuracy, reliability, or availability of the Service.
        </p>
        <p>
          Nutrition information provided through the Service is for informational purposes only and 
          should not be considered as medical or nutritional advice.
        </p>
      </div>
    </section>

    <section>
      <h2 className="text-xl font-semibold mb-3">10. Limitation of Liability</h2>
      <p className="text-gray-600">
        To the fullest extent permitted by law, DinnerBrain shall not be liable for any indirect, 
        incidental, special, consequential, or punitive damages arising from your use of the Service.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold mb-3">11. Indemnification</h2>
      <p className="text-gray-600">
        You agree to indemnify and hold harmless DinnerBrain from any claims, losses, damages, 
        liabilities, and expenses arising from your use of the Service or violation of these Terms.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold mb-3">12. Termination</h2>
      <p className="text-gray-600">
        We may terminate or suspend your account at any time for violations of these Terms. You may 
        also delete your account at any time through your account settings. Upon termination, your 
        right to use the Service will immediately cease.
      </p>
    </section>
  </>
);